import ComparePanelWrapper from './ComparePanelContainer';

export default ComparePanelWrapper;